import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=5f08ab26&scoped=true"
import script from "./SystemInfo.vue?vue&type=script&lang=ts"
export * from "./SystemInfo.vue?vue&type=script&lang=ts"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=5f08ab26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08ab26",
  null
  
)

export default component.exports